import banners from "./banners";
import boards from "./boards";
import center from "./center";
import levels from "./levels";
import cps from "./cps";
import me from "./me";
import pins from "./pins";
import popups from "./popups";
import setting from "./setting";
import terms from "./terms";
import users from "./users";
import * as logs from "./logs";
import * as ip from "./ip"
export default {
    banners,
    boards,
    center,
    levels,
    cps,
    me,
    pins,
    popups,
    setting,
    terms,
    users,
    ...logs,
    ...ip,
};